import { gql, useQuery } from "@apollo/client";
import { UserProfile } from "./schema/UserProfile";

export const userProfileQuery = gql`
  query UserProfile {
    tenant {
      access {
        me {
          name
          firstName
          lastName
          email
          roles
          permissions
        }
      }
    }
  }
`;

export default function useUserProfile() {
  const { data, loading, error } = useQuery<UserProfile>(userProfileQuery, {
    fetchPolicy: "cache-first"
  });
  return {
    data: data?.tenant.access.me,
    loading,
    error
  };
}
